module.exports = __webpack_public_path__ + "img/简历.8afc538f.png";